import Classroom from '@/components/schools/Classroom';
import Hero from '@/components/schools/Hero';
import Quote from '@/components/schools/Quote';
import SuccessStories from '@/components/schools/SuccessStories';
import TakeCare from '@/components/schools/TakeCare';
import ThankYou from '@/components/schools/ThankYou';
import WhatYouGet from '@/components/schools/WhatYouGet';
import { useAnalytics } from '@/hooks/analytics';
import redirect from '@/utils/legacy/redirect';

import { OnCtaClick } from './types';

const SchoolsLayout = () => {
	const { logEventAsync } = useAnalytics();
	const onCtaClick: OnCtaClick = async (copy: string) => {
		await logEventAsync({
			eventName: 'Schools : CTA : Clicked',
			eventProps: {
				copy,
				type: 'button',
			},
		});
		redirect('/schools/resources');
	};

	return (
		<>
			<Hero onCtaClick={onCtaClick} />
			<Quote />
			<Classroom onCtaClick={onCtaClick} />
			<WhatYouGet onCtaClick={onCtaClick} />
			<TakeCare onCtaClick={onCtaClick} />
			<SuccessStories onCtaClick={onCtaClick} />
			<ThankYou onCtaClick={onCtaClick} />
		</>
	);
};

export default SchoolsLayout;
